"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Icon_1 = __importDefault(require("../Icon/Icon"));

var Alert = function Alert(_a) {
  var children = _a.children,
      className = _a.className,
      header = _a.header,
      icon = _a.icon,
      _b = _a.tag,
      Tag = _b === void 0 ? 'div' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'primary' : _c,
      _d = _a.hideIcon,
      hideIcon = _d === void 0 ? false : _d,
      other = __rest(_a, ["children", "className", "header", "icon", "tag", "theme", "hideIcon"]);

  var classes = classnames_1.default(className, 'alert ', "alert-" + theme);
  var iconsByTheme = {
    danger: 'alert',
    success: 'approvalTick',
    info: 'info'
  };
  return react_1.default.createElement(Tag, __assign({}, other, {
    className: classes
  }), header && react_1.default.createElement("h4", {
    className: "alert-heading"
  }, header), react_1.default.createElement("div", {
    className: "d-flex align-items-start"
  }, !hideIcon && (iconsByTheme[theme] || icon) && react_1.default.createElement(Icon_1.default, {
    className: "mr-half flex-shrink-0",
    name: icon || iconsByTheme[theme],
    theme: theme,
    size: 18,
    style: {
      marginTop: '3px'
    }
  }), react_1.default.createElement("span", null, children)));
};

exports.default = Alert;